// import Swup from 'swup';
// import SwupBodyClassPlugin from '@swup/body-class-plugin';
// import SwupScriptsPlugin from '@swup/scripts-plugin';
// import SwupScrollPlugin from '@swup/scroll-plugin';
// import SwupJsPlugin from '@swup/js-plugin';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Flip } from "gsap/Flip";
import Swiper from 'swiper/bundle';

import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

import 'jquery-nice-select/js/jquery.nice-select.min.js';

gsap.registerPlugin(ScrollTrigger, Flip);

$=jQuery;
function addLoadEvent(func) {
    var oldonload = window.onload;
    if (typeof window.onload != 'function') {
        window.onload = func;
    } else {
        window.onload = function () {
            oldonload();
            func();
        };
    }
}

jQuery(function ($) {

    // --- NAV ---

    $(".nav-search").click(function () {
        $(".nav-search-modal").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-search-modal .search-close").click(function () {
        $(".nav-search-modal").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-cart").click(function () {
        $(".nav-cart-modal").toggleClass("active");
        $(".nav-responsive").removeClass("active");
        $(".nav-cart-overlay").toggleClass("active");
        $(".burger").removeClass("active")
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-cart-modal .cart-close").click(function () {
        $(".nav-cart-modal").toggleClass("active");
        $(".nav-cart-overlay").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-burger, .nav-responsive-overlay").click(function () {
        $(".burger").toggleClass("active");
        $(".nav-responsive").toggleClass("active");
        $(".nav-responsive-overlay").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });
    $(".nav-cart-overlay").click(function () {
        $(".nav-cart-modal").toggleClass("active");
        $(".nav-cart-overlay").toggleClass("active");
        $("html").toggleClass("block-viewport");
        $("body").toggleClass("block-viewport");
    });

    $(".nav-responsive ul.menu > li.menu-item-has-children > a").on("click", function(e){
        e.preventDefault();
        e.stopPropagation();

        var $this = $(this);
        var $parent = $this.parents("li").first();

        var $subMenu = $("ul.sub-menu", $parent);
        if($subMenu.is(":visible")) {
            $subMenu.hide();
        } else {
            $(".nav-responsive ul.menu li ul.sub-menu").hide();
            $subMenu.show();
        }
    });

    $(".page-single article .gallery br").remove();

    // --- BURGER ANIMATED ---

    $('#nav-burger-animated').click(function () {
        $(this).toggleClass('open');
    });

    // --- NOTICE ALERT ---

    $(".notice-alert-close").click(function () {
        $(".notice-alert").slideUp();
    });

    // --- WORDPRESS FORM CONTROL ---

    $(".widget_archive select").addClass("form-control");
    $(".widget_categories select").addClass("form-control");
    $(".woocommerce-account .woocommerce").addClass("row justify-content-between");

    // --- WOOCOMMERCE ---

    $(document).off('click', '.product-quantity-minus').on('click', '.product-quantity-minus', function(e) {
        var quantityInput = $(this).closest(".quantity").children("input");
        var currentQuantity = parseInt($(quantityInput).val());
        var newQuantity = (currentQuantity >= 1) ? (currentQuantity - 1) : 0;
        $(quantityInput).val(newQuantity);
        $('.col-woo-cart .actions .update').prop("disabled", false);
    });

    $(document).off('click', '.product-quantity-plus').on('click', '.product-quantity-plus', function(e) {
        var max_quantity = 99999;
        var quantityInput = $(this).closest(".quantity").children("input");
        var currentQuantity = parseInt($(quantityInput).val());
        if(isNaN(currentQuantity)) currentQuantity = 0;
        var newQuantity = (currentQuantity >= max_quantity) ? max_quantity : (currentQuantity + 1);
        $(quantityInput).val(newQuantity);
        $('.col-woo-cart .actions .update').prop("disabled", false);
    });


    $(document.body).trigger('wc_fragment_refresh');


    $('.form-select').niceSelect();

    // --- CF7 ERROR MESSAGE ---
    $(".wpcf7-form-control-wrap").click(function () {
        $(this).children(".wpcf7-not-valid-tip").css("display", "none");
    });
    // --- CF7 NOT-VALID ---
    $(".wpcf7-form-control-wrap").click(function () {
        $(this).children(".wpcf7-form-control").removeClass("wpcf7-not-valid");
    });

});

// === SHOW/HIDE NAV ===
function initShowHideNav() {
    const showhideNav = gsap.from('.nav-sticky', {
        opacity: 0,
        // yPercent: -100,
        paused: true,
        duration: 0.5,
    }).progress(1);

    ScrollTrigger.create({
        start: 'top top',
        end: 99999,
        onUpdate: (self) => {
            const navSticky = document.querySelector('.nav-sticky');
            if (self.direction === -1) {
                showhideNav.play();
                navSticky.classList.add('has-bg');
            } else {
                showhideNav.reverse();
                navSticky.classList.add('has-scrolled');
            }

            const minScrollTop = document.body.classList.contains('admin-bar') ? 32 : 0;
            if (window.scrollY <= minScrollTop) {
                navSticky.classList.remove('has-scrolled');
                navSticky.classList.remove('has-bg');
            }
        },
    });
}
initShowHideNav();


// === SWIPER ===
// --- PRODUCT-SWIPER ---
function initProductsSwiper() {
    var swiper = new Swiper(".product-swiper", {
        effect: "cards",
        grabCursor: true,
        navigation: {
            nextEl: ".product-swiper .swiper-next",
            prevEl: ".product-swiper .swiper-prev",
        },
    });
}
initProductsSwiper();

// --- LAST POSTS SWIPER ---
function initLastPostsSwiper() {
    let swiperLastPosts;
    const isBlogPage = document.body.classList.contains('blog');
    const path = window.location.pathname;
    if(!isBlogPage && !path.includes('category') && !path.includes('single')) {
        if( swiperLastPosts ) {
            swiperLastPosts.destroy(true, true);
        }
        if( window.innerWidth >= 1200 ) {
            swiperLastPosts = new Swiper(".swiper-last-posts", {
                grabCursor: true,
                slidesPerView: 3,
                spaceBetween: 16,
                navigation: {
                    nextEl: ".section__cta--actus .swiper-navigation .swiper-next",
                    prevEl: ".section__cta--actus .swiper-navigation .swiper-prev",
                },
            });
            let navElement = document.querySelector('.section__cta--actus .swiper-navigation');
            if(navElement) {
                navElement.style.display = 'none';
            }
        } else if( window.innerWidth >= 768 ) {
            swiperLastPosts = new Swiper(".swiper-last-posts", {
                grabCursor: true,
                slidesPerView: 2,
                spaceBetween: 16,
                navigation: {
                    nextEl: ".section__cta--actus .swiper-navigation .swiper-next",
                    prevEl: ".section__cta--actus .swiper-navigation .swiper-prev",
                },
            });
            let navElement = document.querySelector('.section__cta--actus .swiper-navigation');
            if(navElement) {
                navElement.style.display = 'flex';
            }
        } else {
            swiperLastPosts = new Swiper(".swiper-last-posts", {
                grabCursor: true,
                effect: "creative",
                creativeEffect: {
                    prev: {
                        shadow: true,
                        translate: [0, 0, -400],
                    },
                    next: {
                        translate: ["105%", 0, 0],
                    },
                },
                navigation: {
                    nextEl: ".section__cta--actus .swiper-navigation .swiper-next",
                    prevEl: ".section__cta--actus .swiper-navigation .swiper-prev",
                },
            });
            let navElement = document.querySelector('.section__cta--actus .swiper-navigation');
            if(navElement) {
                navElement.style.display = 'flex';
            }
        }
    }
}
initLastPostsSwiper();
window.addEventListener('resize', initLastPostsSwiper);




// === MASONRY ===
function initMasonry() {
    const grids= document.querySelectorAll('.masonry');
    grids.forEach((grid) => {
        imagesLoaded(grid, function() {
            const msnry = new Masonry(grid, {
                itemSelector: '.masonry-item',
                columnWidth: '.masonry-sizer',
                percentPosition: true,
                horizontalOrder: true
            });
        });
    });
}
initMasonry();


// === SCROLLER ===
function initScroller() {
    if (!document.body.classList.contains('single-product')) {
        var scroller = document.querySelector('.scroller');
        if( scroller ) {
            scroller.addEventListener('click', function () {
                const headerHeight = document.querySelector('.section--header').offsetHeight;
                window.scroll({
                    top: headerHeight,
                    behavior: 'smooth'
                });
            });
        }
    }
}
initScroller();




// === MODAL DETAILS GROUPES ===
function initGroupsModals() {
    let overlay = document.querySelector('.modalOverlay');
    let mirrorDiv = document.querySelector('.post-item--groupes.active');
    let contentDiv = document.querySelector('.contentDiv');

    // --- CREATE OVERLAY ---
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'modalOverlay';
        overlay.style.position = 'fixed';
        overlay.style.top = 0;
        overlay.style.bottom = 0;
        overlay.style.left = 0;
        overlay.style.right = 0;
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        overlay.style.zIndex = 9998;
        overlay.style.visibility = 'hidden';

        document.body.appendChild(overlay);
    }

    // --- CREATE MIRRORDIV WITH CONTENT ---
    if (!mirrorDiv) {
        mirrorDiv = document.createElement('div');
        mirrorDiv.className = 'post-item--groupes active';
        mirrorDiv.style.position = 'fixed';
        mirrorDiv.style.top = '50%';
        mirrorDiv.style.left = '50%';
        mirrorDiv.style.transform = 'translate(-50%, -50%)';
        mirrorDiv.style.width = '100%';
        mirrorDiv.style.maxWidth = getWindowWidth();
        mirrorDiv.style.height = 'auto';
        mirrorDiv.style.maxHeight = '75vh';
        mirrorDiv.style.zIndex = 9999;
        mirrorDiv.style.visibility = 'hidden';

        document.body.appendChild(mirrorDiv);
    }

    // --- CREATE SCROLLABLE CONTENT ---
    if (!contentDiv) {
        contentDiv = document.createElement('div');
        contentDiv.className = 'contentDiv';
        contentDiv.style.height = 'auto';
        contentDiv.style.maxHeight = '75vh';
        contentDiv.style.overflowY = 'scroll';

        mirrorDiv.appendChild(contentDiv);

    }

    window.addEventListener('resize', () => {
        mirrorDiv.style.maxWidth = getWindowWidth();
    });
    // --- DEFINE CONTENT-WIDTH ---
    function getWindowWidth() {
        let windowWidth = window.innerWidth;

        if( windowWidth < 768 ) {
            return '355px';
        } else if( windowWidth < 1200 ) {
            return '576px';
        } else if( windowWidth < 1400 ) {
            return '1080px';
        } else {
            return '1320px';
        }
    }

    document.querySelectorAll('.more').forEach((button) => {
        button.addEventListener('click', (e) => {
            e.stopPropagation();

            const postItem = e.target.closest('.post-item--groupes');

            // --- COPY CONTENT in MIRRORDIV ---
            contentDiv.innerHTML = postItem.innerHTML;
            mirrorDiv.style.visibility = 'visible';
            overlay.style.visibility = 'visible';

            // --- ADD LISTENER CLOSE BTN IN MIRRORDIV
            mirrorDiv.querySelectorAll('.close').forEach((closeButton) => {
                closeButton.addEventListener('click', (e) => {
                    e.stopPropagation();
                    gsap.to(mirrorDiv, {
                        scale: 0.1,
                        opacity: 0,
                        duration: .35,
                        onComplete: () => {
                            mirrorDiv.style.visibility = 'hidden';
                            contentDiv.innerHTML = '';
                            overlay.style.visibility = 'hidden';
                            // Réactivation du scroll
                            document.body.style.overflow = 'initial';
                        },
                    });
                });
            });

            // Désactivation du scroll
            document.body.style.overflow = 'hidden';

            gsap.fromTo(mirrorDiv, {
                scale: 0.1,
                opacity: 0
            }, {
                scale: 1,
                opacity: 1,
                duration: .5
            });
        });
    });

    // --- CLOSE MIRRORDIV & OVERLAY ON OVERLAY CLICK ---
    overlay.addEventListener('click', closeDivAndOverlay);

    // --- CLOSE MIRRORDIV & OVERLAY ---
    function closeDivAndOverlay() {
        gsap.to(mirrorDiv, {
            scale: 0.1,
            opacity: 0,
            duration: .35,
            onComplete: () => {
                mirrorDiv.style.visibility = 'hidden';
                contentDiv.innerHTML = '';
                overlay.style.visibility = 'hidden';

                // Réactivation du scroll
                document.body.style.overflow = 'initial';
            },
        });
    }
}
if( document.body.classList.contains('home') ) {
    initGroupsModals();
}

// document.addEventListener('swup:clickLink', function(event) {
//     var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
//
//     if (viewportWidth <= 1200) {
//         var burger = document.querySelector('.burger');
//         var navResponsive = document.querySelector('.nav-responsive');
//         var navOverlay = document.querySelector('.nav-responsive-overlay');
//         var htmlElement = document.querySelector('html');
//         var bodyElement = document.querySelector('body');
//
//         if (burger.classList.contains('active')) {
//             // Fermez le menu et retirez la classe active.
//             burger.classList.remove('active');
//             navResponsive.classList.remove('active');
//             navOverlay.classList.remove('active');
//             htmlElement.classList.remove('block-viewport');
//             bodyElement.classList.remove('block-viewport');
//             // Empêcher la transition immédiate.
//             event.preventDefault();
//             event.stopPropagation();
//
//             // Retarder la transition de page.
//             setTimeout(function() {
//                 swup.options.linkSelector = event.delegateTarget;
//                 swup.transition();
//             }, 4500); // Changez ce nombre pour ajuster le délai (en millisecondes).
//         }
//     }
// });
//
//
// const SwupOptions = [
//     {
//         from: '(.*)',
//         to: '(.*)',
//         in: (next) => {
//             let transitionContainer = document.querySelector('.transition-container');
//             let transitionLogo = document.querySelector('.transition-container svg');
//
//             gsap.fromTo(transitionContainer, { opacity: 1 }, { opacity: 0, delay: .5, duration: 1.5 });
//             gsap.fromTo(transitionLogo, { scale: 0, opacity: 0 }, { scale: .25, opacity: 1, duration: .75 })
//                 .then(() => gsap.to(transitionLogo, { opacity: 0, duration: 0.75 }));
//         },
//         out: (next) => {
//             gsap.to(document.querySelector('.transition-container'), { opacity: 1, duration: 1 })
//                 .then(() => next());
//         }
//     }
// ];
//
//
// const swup = new Swup(
//     {
//         plugins: [
//             new SwupBodyClassPlugin(),
//             new SwupScriptsPlugin(
//                 {
//                     head: false
//                 }
//             ),
//             new SwupScrollPlugin(
//                 {
//                     doScrollingRightAway: true,
//                     animateScroll: false
//                 }
//             ),
//             new SwupJsPlugin(SwupOptions)
//         ],
//     }
// );
//
// swup.on('contentReplaced', function() {
//     var htmlElement = document.querySelector('html');
//     var bodyElement = document.querySelector('body');
//     if(htmlElement.classList.contains('block-viewport')) {
//         htmlElement.classList.remove('block-viewport');
//     }
//     if(bodyElement.classList.contains('block-viewport')) {
//         bodyElement.classList.remove('block-viewport');
//     }
//     if( document.body.classList.contains('home') ) {
//         initGroupsModals();
//     } else {
//         // CLEAN ITEMS CREATED BY initGroupsModals
//         // ON OTHER PAGES
//         let modalOverlay = document.querySelector('.modalOverlay');
//         let mirrorDiv = document.querySelector('.post-item--groupes.active');
//         let contentDiv = document.querySelector('.contentDiv');
//
//         if(modalOverlay) modalOverlay.remove();
//         if(mirrorDiv) mirrorDiv.remove();
//         if(contentDiv) contentDiv.remove();
//     }
//
//     yith_wccl();
// });
//
// // Supprimer la div parente contenant le badge existant
// let existingBadge = document.querySelector('.grecaptcha-badge');
// if (existingBadge && existingBadge.parentNode) {
//     existingBadge.parentNode.parentNode.removeChild(existingBadge.parentNode);
// }
//
// // Charger le script de reCAPTCHA si ce n'est pas déjà fait
// if (!document.querySelector('script[src="https://www.google.com/recaptcha/api.js"]')) {
//     let script = document.createElement('script');
//     script.src = 'https://www.google.com/recaptcha/api.js';
//     document.body.appendChild(script);
// }

